
/**
 * 
 * @returns 
* Title Banner for Website used for announcements and welcoming visitors
*/

import React from 'react';
import Pdf from '../images/Yardi_Delayed_Payments_LL Memo_2025.pdf';
import Pdf2 from '../images/254790_Lot_A_Loan_Program_Brochure.pdf';

export default function LoggedInBanner()
{
    return(
        <div className='padding'>                

            <div className='text-center loggedInBanner'>
                <br></br>
                <h4 className='emphTitle3'><u>VIEW PAYMENTS</u></h4>
                <p className='emphTitle2'>Use this link or click on Payments above in the navigation menu to view payments <a className='btn buttons'  href='/payments'>VIEW MY PAYMENTS</a></p> 
                <h4 className='paddingBottom whiteFont'>Questions or Comments?</h4>
                <a className='whiteFont emphTitle text-center m_register btn btnColor ' href='/faq'>VISIT OUR FAQ PAGE</a>
                <br></br>
            </div>
            <br></br>
            <div className='text-center  loggedInBanner'>
                <br></br>
                <br></br>

                <h3 className='whiteFont emphTitle3 text-center'><u>PAYMENT UPDATE</u></h3>
                <h5 className='whiteFont'>SECTION 8 PAYMENTS: 01/01/2026</h5>
                <h5 className='whiteFont'>MRVP PAYMENTS: 01/07/2026</h5>
                <h5 className='whiteFont'>RAFT/HOMEBASE PAYMENTS: 01/09/2026</h5>
                <h5 className='whiteFont'>WSD PAYMENTS: 01/15/2026</h5>

                <h5 className='whiteFont emphTitle2 hide'>
                    We wanted to inform you of a potential delay in rental subsidy payments for the Section 8 and MRVP scheduled to be issued to you in early February. 
                    Please visit the Messages section for more information<a className='whiteFont emphTitle text-center m_register btn btnColor ' href='/main'>MESSAGES AND ALERTS</a>

                </h5>
                <h5 className='whiteFont emphTitle2 hide'>
                    For any new account creation or updates to your account information or login credentials, please reach out and provide us with either the W9, the name of a tenant and address, or the TAXID.
                </h5> 
                <h5 className='whiteFont emphTitle2 '>
                    <p>2025 Remittance Update:  <a className='btn btn-primary buttons' target='_blank' rel='noreferrer' href={Pdf} >Yardi_Delayed_Payments_LL Memo_2025</a></p>
                    <p>Loan Program Brochure Update:  <a className='btn btn-primary buttons' target='_blank' rel='noreferrer' href={Pdf2} >254790_Lot_A_Loan_Program_Brochure</a></p>
                </h5>                 
            </div>
        </div>
        
    );
}